const notificate = (context, message, type, details = []) => {
  if(message)
    context.$_notify({ text: message, type, data: details })
}

export {
  notificate
}